<template>
  <div id="search" class="mx-auto text-center">
    <h4>Search for a Small Group</h4>
    <b-form @submit="searchSubmit" class="form">
      <div class="input-group">
        <input 
          type="text"
          class="form-control"
          v-model="searchterm"
          placeholder="Search by group leader name..."
          v-on:keyup="filterSearchData" />
        <div class="input-group-append">
          <a class="btn btn-dark" href="#grouplist">Submit</a>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
export default {
  name: 'Search',
  props: {
    searchData: Array
  },
  data() {
    return {
      searchterm: '',
      filteredData: []
    }
  },
  methods: {
    filterSearchData() {
      this.filteredData = this.searchData
      if (this.searchterm !== '') {
        let filteredDataBySearch = this.filteredData.filter(obj => {
          return obj.leader.toLowerCase().includes(this.searchterm.toLowerCase())
        })
        this.filteredData = filteredDataBySearch
      } else {
        this.filteredData = this.searchData
      }
      this.$root.$emit('filter-search-complete', this.filteredData)
    },
    searchSubmit(evt) {
      evt.preventDefault()
      this.$emit('scrollto', 'grouplist')
    }
  }
}
</script>

<style>
#search {
  width: 45%;
  min-width: 270px;
  max-width: 400px;
}
</style>
